import { useSelector } from 'react-redux'

import { useFormikContext, getIn } from 'formik'

import { AddressesOptions } from '~/address/models/address.model'
import { Owner } from '~/basket/model/lines/signup.model'
import { Billing } from '~/payments/model/billing.model'
import { selectIban } from '~/payments/store/payments.selectors'
import useValidateForm from '~/sale/hooks/useValidateForm'

export default function useBillingForm() {
  const { values } = useFormikContext<Billing>()
  const iban = useSelector(selectIban)

  const selectedAddress = getIn(values, 'address')
  const showOtherAddress = selectedAddress === AddressesOptions.OTHER

  const showPaymentOwner = getIn(values, 'paymentOwner.owner') === Owner.OTHER

  useValidateForm({
    lineId: 'all',
    form: 'billing',
    isValidForm: !!iban.isValid,
    refreshValue: !!iban.isValid && !!showPaymentOwner,
  })

  return { showPaymentOwner, showOtherAddress }
}
